import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpHelper } from 'src/app/common/index';



@Injectable()
export class ELearningService {

  constructor(public httpHelper: HttpHelper,
              private http: HttpClient) {

  }

  getEmployees():Observable<any> {
    return this.httpHelper.getRequest(`/employees`);
  }

  saveFile(file):Observable<any> {
    return this.httpHelper.postFile(`/e-learning/upload/file`,file);
  }

  createCourse(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/course`, params);
  }

  deleteCourse(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/course`, params);
  }

  getCourse(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/course`, params);
  }

  getSingleCourse(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/single/course`, params);
  }

  getCoursesByUser(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/courses/by/user`, params);
  }

  createProfessorBiography(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/professor/biography`, params);
  }

  createSessions(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/sessions`, params);
  }

  getSessions(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/sessions`, params);
  }

  getSessionsByID(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/sessions/by/id`, params);
  }

  deleteSessionsByID(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/sessions/by/id`, params);
  }

  updateSortedOrderID(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/update/sessions/order/id`, params);
  }

  createSessionsResources(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/sessions/resources`, params);
  }

  getResourcesForSessions(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/all/resources/for/sessions`, params);
  }

  deleteResourcesForSessionsByID(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/resources/for/sessions/by/id`, params);
  }

  createQuizzes(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/quizzes`, params);
  }

  createQuizzesQuestions(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/quizzes/questions`, params);
  }

  createQuizzesAnswers(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/quizzes/answers`, params);
  }

  createQuizzesSubmissions(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/quizzes/submissions`, params);
  }

  getQuizzesSubmissionsByID(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/quizzes/submissions/by/id`, params);
  }

  getQuizzesWithQuestionsAndAnswers(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/quizzes/questions/and/answers`, params);
  }

  createSingleQuestionAndAnswers(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/single/question/and/answers`, params);
  }

  getSingleQuestionAndAnswers(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/single/question/and/answers`, params);
  }

  deleteQuizzes(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/quizzes`, params);
  }

  deleteQuestion(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/question`, params);
  }

  deleteAnswers(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/answer`, params);
  }

  createSettings(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/settings`, params);
  }

  getSettings(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/settings`, params);
  }

  getSettingsByName(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/settings/by/name`, params);
  }

  getNewCourseIdNumber(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/new/course/id/number`, params);
  }

  createEnrolledCourses(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/enrolledCourses`, params);
  }

  createMultipleEnrolledCoursesByFunction(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/multiple/enrolledCourses/by/function`, params);
  }

  getEnrolledCourses(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/enrolledCourses`, params);
  }

  getEnrolledStatus(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/enrolled/status`, params);
  }

  getEnrolledParticipants(course_id_number,state,filter):Observable<any> {
    const queryStr = `skip=${state.skip}&take=${state.take}`;
    return this.httpHelper.postRequest(`/e-learning/get/enrolled/participants/${course_id_number}?${queryStr}`, filter);
  }

  deleteEnrolledParticipant(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/delete/enrolled/participant`, params);
  }

  isUserEnrolledToCourse(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/is/user/enrolled/to/course`, params);
  }

  checkIfUserIsProfessor(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/check/if/user/is/professor`, params);
  }

  getSingleCourseReports(courseID,state,filter):Observable<any> {
    const queryStr = `skip=${state.skip}&take=${state.take}`;
    return this.httpHelper.postRequest(`/e-learning/get/reports/for/single/course/${courseID}?${queryStr}`, filter);
  }

  getSingleProfessorReports(professorID,state,filter):Observable<any> {
    const queryStr = `skip=${state.skip}&take=${state.take}`;
    return this.httpHelper.postRequest(`/e-learning/get/reports/for/single/professor/${professorID}?${queryStr}`, filter);
  }

  createGrapesJsTemplate(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/grapesjs/template`, params);
  }

  getGrapesJsTemplate(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/grapesjs/template`, params);
  }

  getUserProgress(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/user/progress`, params);
  }

  createUserProgress(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/user/progress`, params);
  }

  generateDiploma(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/generate/diploma`, params);
  }

  getProfessorsAccess(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/get/professors/access`, params);
  }

  createProfessorsAccess(params):Observable<any> {
    return this.httpHelper.postRequest(`/e-learning/create/professors/access`, params);
  }

}
